import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './pages/AboutPage';
import Chatbox from './pages/chatbox/Chatbox';
import FirstPage from './pages/FirstPage';
import { ChatboxHeaders, NotFoundHead } from './utils/seo';
export default function App() {
  return (
    <Router>
      <div className="h-full">
        <div className="flex md:gap-10 gap-6 justify-between flex-col overflow-x-hidden text-center h-[100svh]">
          <Routes>
            <Route index element={<FirstPage />} />
            <Route
              path="ask"
              element={
                <div className="h-[100svh]">
                  <ChatboxHeaders />
                  <Chatbox disabled={false} />
                </div>
              }
            />
            {/* <Route
              path="ask-hidden"
              element={
                <div className="h-[100svh]">
                  <ChatboxHeaders />
                  <Chatbox disabled={false}/>
                </div>
              }
            /> */}
            <Route path="about" element={<About />} />
            <Route
              path="*"
              element={
                <main className="my-auto px-6 text-left max-w-xl mx-auto">
                  <NotFoundHead />
                  <h1 className="balance font-display text-display-lg-sm">
                    Page not found
                  </h1>
                  <p className="mt-4 text-body text-muted">
                    That page doesn't exist.{' '}
                    <a
                      href="/"
                      className="text-peach underline underline-offset-4 hover:text-peach-soft"
                    >
                      Go to the home page
                    </a>
                    .
                  </p>
                </main>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}
